// extracted by mini-css-extract-plugin
export default {"root":"lYUCu","content":"_4y4tk"};